export { OnboardingTabs } from "./onboarding-tabs.component";
